<template>
  <el-container class="recharge">

    <el-header class="search">

      <el-select
          v-model.number="PayMethod"
          placeholder="付款方式"
          style="width: 125px; margin:0 10px 0 -20px"
          @change="BtnQuery"
        >
          <el-option v-for="item in payMethodData"
          :key="item.value"
          :label="item.name"
          :value="item.value"
          ></el-option>
        </el-select>
      <el-input class="search-text" v-model="keyWord" placeholder="请输入关键字检索..." @keyup.enter.native="BtnQuery"></el-input>
      <el-button type="primary" size="medium" plain icon="el-icon-search" @click="BtnQuery">查询</el-button>
    </el-header>

    <el-main>
      <div v-if="data.length > 0" class="recharge-data">

          <div v-for="item in data" :key='item.ExamId'>
            <el-descriptions :title="item.TypeName" class="descript">
                <el-descriptions-item label="付款方式">
                  <el-tag type="primary" size="mini">{{item.PayTypeStr}}</el-tag>
                </el-descriptions-item>
                <el-descriptions-item label="有效期">
                  <el-tag type="success" size="mini">{{item.ChargeTimeStr}}</el-tag>
                </el-descriptions-item>
                <el-descriptions-item label="付款金额">{{item.PayAmount}}</el-descriptions-item>
                <el-descriptions-item label="付款时间">{{item.PayTime}}</el-descriptions-item>
                <el-descriptions-item label="过期时间">{{item.ExpireTime}}</el-descriptions-item>
            </el-descriptions>
          </div>

      </div>
      
      <empty-data v-else></empty-data>
    </el-main>

    <el-footer v-if="data.length > 0" class="pagaing">
      <el-pagination
            :background="true"
            :current-page="pageIndex"
            :page-size="PageSize"
            :total="total"
            :layout="pageLayout"
            @current-change="PageChange"
            @size-change="SizeChange"
          ></el-pagination>
    </el-footer>
  </el-container>
</template>

<script>

import { GetUserConsumeRecord } from "@/api/category";
import EmptyData from "@/components/EmptyData";

export default {
    components: { EmptyData },
    data() {
        return {
            listLoading: false,
            loadingText: "正在加载...",
            pageLayout: "total, sizes, prev, pager, next, jumper",
            subjectState: null,
            stateData: [
                { value: 0, name: "全部" },
                { value: 1, name: "正常" },
                { value: 2, name: "已过期" }
            ],
            PayMethod: 0,
            payMethodData: [
                { value: 0, name: "全部" },
                { value: 1, name: "充值卡" },
                { value: 2, name: "微信" },
                { value: 3, name: "支付宝" }
            ],
            pageIndex: 1,
            PageSize: 10,
            total: 0,
            // 列表记录
            data: [],
            keyWord: ""
        }
    },
    computed: {},
    watch: {},
    created() {
        this.ConsumeData()
    },
    methods: {
        // 消费信息
        async ConsumeData() {
            const { data } = await GetUserConsumeRecord({
                pageno: this.pageIndex,
                pagesize: this.PageSize,
                payType: this.PayMethod,
                searchKey: this.keyWord,
                sortBy: "PayTime",
                sordOrder: "Desc"
            });
            if (data.code === 100) {
                for (let item of data.data) {
                    item.ChargeTimeStr = "";
                    if (item.ChargeTime === "1") {
                        item.ChargeTimeStr = "一个月"
                    } else if (item.ChargeTime === "2") {
                        item.ChargeTimeStr = "三个月"
                    } else if (item.ChargeTime === "3") {
                        item.ChargeTimeStr = "六个月"
                    } else if (item.ChargeTime === "4") {
                        item.ChargeTimeStr = "一年"
                    } else {
                        item.ChargeTimeStr = "其它"
                    }

                    item.PayTypeStr = "";
                    if (item.PayType === "1") {
                        item.PayTypeStr = "充值卡"
                    } else if (item.PayType === "2") {
                        item.PayTypeStr = "微信"
                    } else if (item.PayType === "3") {
                        item.PayTypeStr = "支付宝"
                    } else {
                        item.PayTypeStr = "其它"
                    }
                }
                this.data = data.data
                this.total = data.count
            }
        },
        // 按钮检索
        BtnQuery() {
            this.pageIndex = 1;
            this.PageSize = 10;
            this.ConsumeData()
        },
        //
        PageChange(val) {
            this.pageIndex = val;
            this.ConsumeData()
        },
        //
        SizeChange(val) {
            this.PageSize = val
            this.ConsumeData()
        }
    }
}

</script>

<style scoped lang="less">

  .recharge {
      width: 100%;
      height: 100%;

    .el-main{
      padding: 0 0 5px 0;
      color: black;
      height: 600px;
      overflow: auto;
     &::-webkit-scrollbar {
           width: 6px;
       }

       &::-webkit-scrollbar-track {
           border-radius: 6px;
       }

       &::-webkit-scrollbar-thumb {
           border-radius: 6px;
           background: #BAC0CA;
       }

    }

   .el-footer{
      height: 50px;
      line-height: 50px;
      text-align: center;
      margin-top: 40px;
    }

      .search{
        width: 100%;
        height: 40px;
        line-height: 40px;

        .search-select{
          width:130px;
        }

        .search-text{
          width:250px;
          margin:0 20px 0 0;
        }

        ::v-deep .el-input__inner{
          height: 35px;
        }

      }

    .recharge-data{
       padding: 10px 0 -10px 0;
       color: black;

       .descript{
        border-bottom:1px solid #e5e8ec;
        padding:0 30px 0 10px
      }

      ::v-deep .el-descriptions__header{
        margin: 10px 0 5px 0;
      }
    }

  }

</style>
